import type { UIMatch } from 'react-router'

/** `handle.crumb` on a route: a label, or a function of the match (a family name from loader data). */
export type Crumb = string | ((match: UIMatch) => string)

export interface CrumbHandle {
  crumb?: Crumb
}

export interface CrumbItem {
  label: string
  to: string
}

/**
 * The list a page was opened from, kept in its history entry's state (`{ daftar }`) as a list's
 * search is (`useKueriRiwayat`), so Back and a reload keep it too; null without one. Only an
 * address of the app ("/…", never "//…").
 */
export function daftarDariKeadaan(state: unknown): string | null {
  const daftar =
    typeof state === 'object' && state !== null ? (state as { daftar?: unknown }).daftar : null
  return typeof daftar === 'string' && daftar.startsWith('/') && !daftar.startsWith('//')
    ? daftar
    : null
}

/**
 * The crumbs of the matched routes. The crumb of the list a page was opened from (`daftar`,
 * `daftarDariKeadaan`) opens that address, with the list's open sections and filters
 * (Pelayan & pengurus's `?buka=`), never the bare list.
 */
export function crumbsFromMatches(
  matches: readonly UIMatch[],
  daftar: string | null = null,
): CrumbItem[] {
  const jalurDaftar = daftar?.split(/[?#]/, 1)[0]
  const out: CrumbItem[] = []
  for (const match of matches) {
    const handle = match.handle as CrumbHandle | undefined
    const crumb = handle?.crumb
    if (crumb === undefined) continue
    const label = typeof crumb === 'function' ? crumb(match) : crumb
    if (label.length === 0) continue
    out.push({
      label,
      to: daftar !== null && jalurDaftar === match.pathname ? daftar : match.pathname,
    })
  }
  return out
}
